import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

import background from './assets/background.svg?inline';

export default makeStyles({ name: 'ErrorPage' })((theme) => ({
    root: {
        boxSizing: 'border-box',
        position: 'relative',
        width: '100%',
        height: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: '24px 16px',
        '&:before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            pointerEvents: 'none'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: '16px 8px'
        }
    },
    icon: {
        width: 120,
        height: 120,
        marginBottom: 24,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: 80,
            height: 80,
            marginTop: 'auto'
        }
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        marginBottom: 40,
        maxWidth: 830,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 8,
            marginBottom: 'auto'
        }
    },
    title: {
        margin: 0,
        color: '#232323',
        textAlign: 'center',
        fontSize: 72,
        fontWeight: 700,
        lineHeight: '120%',
        letterSpacing: '-3.24px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 40,
            letterSpacing: '-1.2px'
        }
    },
    description: {
        margin: 0,
        color: '#232323',
        textAlign: 'center',
        fontSize: 32,
        fontWeight: 600,
        lineHeight: '120%',
        letterSpacing: '-0.96px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 18,
            lineHeight: '150%',
            letterSpacing: '-0.54px'
        }
    },
    button: {
        padding: '16px 32px',
        height: 56,
        borderRadius: 16,
        background: '#232323',
        color: '#FFF',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        textTransform: 'none',
        '&:hover': {
            background: '#2D2D2D'
        },
        '&:focus': {
            background: '#2D2D2D'
        },
        '&:active': {
            background: '#151515'
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    }
}));
